<template>
    <div id="app"  v-bind:class="lang">
        <Header :isSafari="isSafari"/>
        <div class="preloader">
            <div class="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
            <LanguageSwitcher/>
            <PageWrapper :pageid="pageid" :kapitel="kapitel"></PageWrapper>

        <Footer/>
    </div>
</template>

<script>
    import Header from "@/components/partials/Header";
    import Settings from "@/settings/settings.json";
    import PageWrapper from "@/views/pages/PageWrapper";
    import LanguageSwitcher from "@/components/LanguageSwitcher";
    export default {

        name: 'App',
        components: {
            Header,
            PageWrapper,
            LanguageSwitcher
        },
        data() {
            return {
                texte: Array,
                lang: "",
                pageid: "010",
                kapitel: "00",
                isSafari: false,
                substitutes : {
                    'red': '<span class="font-color-red">',
                    '/red': '</span>',
                    'quote': '"',
                    'br': '<br>',
                    'bold': '<strong>',
                    '/bold': '</strong>',
                    'italic': '<em>',
                    '/italic': '</em>',
                    'uppercase': '<span class="uppercase">',
                    '/uppercase': '</span>',
                    'small': '<small>',
                    '/small': '</small>',
                    'sup': '<sup>',
                    '/sup': '</sup>',
                    'nobreak': '<span class="nobr">',
                    '/nobreak': '</span>',
                    'span': '<span>',
                    '/span': '</span>',
                }

            }
        },
        created: function () {
            let modulename = Settings["Modulname"];
            let chapters = Settings["Chapters"];
            let lang = Settings["StandardLanguage"];
            let this_ = this;

            this.isSafari = !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && typeof document.body.style.webkitFilter !== "undefined" && !window.chrome;
            this.$store.dispatch("enterModule", {module: modulename, lang: lang, chapters: chapters}).then(function () {
                // this_.texte = this_.$store.getters.translation;
                this_.lang = this_.$store.getters.lang;


            });

            this.$store.watch(
                (state, getters) => getters.lang,
                (newValue, oldValue) => {
                    this.lang = this.$store.getters.lang;
                    console.log(`Updating from ${oldValue} to ${newValue}`);
                }
            )
        },
        methods: {
            getWindowWidth(event) {
                this.windowWidth = document.documentElement.clientWidth;
            },
            getWindowHeight(event) {
                this.windowHeight = document.documentElement.clientHeight;
            },
            openDetailPage(){
                window.open('/makeup-studio_uk_en/complexion/synchro-skin-self-refreshing-custom-finish-powder-foundation/?module=MakeupCompactFoundation&chapter=&mpage=&lang=uk_en',"_self")
            },
            isMobile(){
                if(this.windowWidth <= 768){
                    return true
                } else {
                    return false
                }
            }
        },
        mounted(){

            this.$nextTick(function() {
                window.addEventListener('resize', this.getWindowWidth);
                window.addEventListener('resize', this.getWindowHeight);

                //Init
                this.getWindowWidth()
                this.getWindowHeight()


            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
            window.removeEventListener('resize', this.getWindowHeight);
        },
      watch: {
        '$route.params.pageid': function (id) {
          this.pageid = id;
        },
        '$route.params.kapitel': function (kapitel) {
          this.kapitel = kapitel;
        }
      },

    };
</script>